<template>
  <a-card
    :tab-list="[
    {key:'TEXT',tab:$t('TEXT_CONTENT')||'文字'},
    {key:'IMAGE',tab:$t('IMAGE_CONTENT')||'图片'}
   ]"
    :active-tab-key="this.searchForm.data.type"
    @tabChange="key => onTabChange(key)">
    <div style="height: 32px">
      <a-button type="primary" @click="addAppInfo" style="margin-left: 93%" >
        {{ $t('ADD') || '添加' }}
      </a-button>
    </div>
    <div>
      <a-table
        row-key="id"
        :data-source="table.data.filter(x=>x.type===searchForm.data.type)"
        style="width: 100%">
        <a-table-column
          data-index="title"
          :title="$t('TITLE') || '标题'"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="code"
          :title="$t('CODE') || '编码'"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION') || '操作'">
          <template slot-scope="text, record">
            <a-button type="link" @click="editAppInfo(record.id)">{{ $t('EDIT') || '编辑' }}
            </a-button>
            <a-divider type="vertical"/>
            <a-button type="link" @click="deleteAppInfo(record.id)">删除
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
      :footer="null"
      :title="$t('EDIT')"
      v-model="form.visible">
      <website-app-info-edit
        v-if="form.visible"
        :type="searchForm.data.type"
        :app-info-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </website-app-info-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryAppInfos,
  _deleteAppInfo,
} from '@/api/websiteAppInfoApi';
import WebsiteAppInfoEdit from './WebsiteAppInfoEdit.vue';

async function getAppInfoList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryAppInfos({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
}

function addAppInfo() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editAppInfo(appInfoId) {
  this.form.data.id = appInfoId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getAppInfoList();
}

async function deleteAppInfo(appInfoId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteAppInfo(appInfoId);
      this.$message.success(this.$t('REMOVE_SUCCESS'));
      await this.getAppInfoList();
    },
  });
}

function onTabChange(key) {
  this.searchForm.data.type = key;
}

export default {
  name: 'WebsiteAppInfoList',
  components: {
    WebsiteAppInfoEdit,
  },
  data() {
    return {
      searchForm: {
        data: {
          type: 'TEXT',
        },
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      size: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'id',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getAppInfoList,
    deleteAppInfo,
    editAppInfo,
    addAppInfo,
    closeForm,
    onTabChange,
  },
  created() {
    this.getAppInfoList();
  },
};
</script>

<style scoped>

</style>
